import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium mt-5 mb-2 text-[12px]" }, "Ingrese los datos", -1)
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = ["disabled"]

import { computed, ref } from "vue";
import Modal from "@/components/atoms/Modal.vue";
import TextField from "@/components/atoms/TextField.vue";

import { useAuthStore } from "@/stores/auth";
import { AccountService } from "@/services/account/AccountService";
import { accountStore } from "@/stores/account";
import Swal from "sweetalert2";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAccountModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {





const accountStoreStr = accountStore();
const authStore = useAuthStore();

const accountService = new AccountService();
const loading = ref(false);

// Información basica

const backCode = ref<number>(0);
const backName = ref<string>("");
const accountType = ref<string>("");
const accountNumber = ref<string>("");
const accountOwnerName = ref<string>("");
const accountOwnerRut = ref<string>("");
const accountEmail = ref<string>("");

/**
 * Comprueba si el valor ingresado como parámetro es nulo o no definido.
 * @param value Valor a comprobar
 */
function isNullOrEmpty(value?: string | number | null): boolean {
  return !value || value == null || value == "" || value == 0;
}
function isEmptyOrZero(value?: number): boolean {
  return !value || value == null || value == 0;
}
function isEmptyOrLarge(value?: string): boolean {
  return (
    !value ||
    value == null ||
    value == "" ||
    value.length == 0 ||
    value.length > 35
  );
}
function isRut(value?: string): boolean {
  return (
    !value ||
    value == null ||
    value == "" ||
    value.length == 0 ||
    value.length > 35
  );
}

// Indica si el formulario tiene algun error de dato o valor requerido
const formHasError = computed(() => {
  const requiredFields = [
    backCode.value,
    backName.value,
    accountType.value,
    accountNumber.value,
    accountOwnerName.value,
    accountOwnerRut.value,
    accountEmail.value,
  ];

  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }

  // Listao de posibles errores del formulario de registro
  const formErrors = [
    backCodeFieldHasError.value,
    backNameFieldHasError.value,
    accountTypeFieldHasError.value,
    accountNumberFieldHasError.value,
    accountOwnerNameFieldHasError.value,
    accountOwnerRutFieldHasError.value,
    accountEmailFieldHasError.value,
  ];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }

  return false;
});

const backCodeFieldHasError = computed(() => {
  return isEmptyOrZero(backCode.value);
});

const backNameFieldHasError = computed(() => {
  return isEmptyOrLarge(backName.value);
});

const accountTypeFieldHasError = computed(() => {
  return isEmptyOrLarge(accountType.value);
});

const accountNumberFieldHasError = computed(() => {
  return isEmptyOrLarge(accountNumber.value);
});
const accountOwnerNameFieldHasError = computed(() => {
  return isEmptyOrLarge(accountOwnerName.value);
});

const accountOwnerRutFieldHasError = computed(() => {
  return isRut(accountOwnerRut.value);
});

const accountEmailFieldHasError = computed(() => {
  return isEmptyOrLarge(accountEmail.value);
});
/**
 * Envia una solicitud al backend para registrar al nuevo accionista
 */
async function registerNewAccount() {
  loading.value = true;

  try {
    const response = await accountService.registerNewAccount(
      backCode.value,
      backName.value,
      accountType.value,
      accountNumber.value,
      accountOwnerName.value,
      accountOwnerRut.value,
      accountEmail.value
    );
    if (response.success == true) {
      loading.value = false;
      emit("update:visible", false);

      if (authStore.user?.id) {
        accountStoreStr.query(authStore.user.id);
      }

      backCode.value = 0;
      backName.value = "";
      accountType.value = "";
      accountNumber.value = "";
      accountOwnerName.value = "";
      accountOwnerRut.value = "";
      accountEmail.value = "";
      Swal.fire("¡Listo!", "La cuenta se ha creado con éxito", "success");
    } else {
      Swal.fire(
        "¡Error!",
        "Lo sentimos, hubo un error, intente más tarde",
        "error"
      );
    }
  } catch (error) {
    console.log(error);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    title: "Crear nueva cuenta",
    class: "p-8",
    visible: __props.visible,
    "onUpdate:visible": _cache[7] || (_cache[7] = (e) => _ctx.$emit('update:visible', e))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextField, {
          model: backCode.value,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((backCode).value = $event)),
          "has-error": _unref(backCodeFieldHasError),
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "number",
          name: "backCode",
          label: 'Código del banco',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: backName.value,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((backName).value = $event)),
          "has-error": _unref(backNameFieldHasError),
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "backName",
          label: 'Nombre del banco',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: accountType.value,
          "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((accountType).value = $event)),
          "has-error": _unref(accountTypeFieldHasError),
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountType",
          label: 'Tipo de cuenta',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: accountNumber.value,
          "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((accountNumber).value = $event)),
          "has-error": _unref(accountNumberFieldHasError),
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "number",
          name: "accountNumber",
          label: 'Número de cuenta',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: accountOwnerName.value,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((accountOwnerName).value = $event)),
          "has-error": _unref(accountOwnerNameFieldHasError),
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountOwnerName",
          label: 'Titular de cuenta',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: accountOwnerRut.value,
          "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((accountOwnerRut).value = $event)),
          "has-error": _unref(accountOwnerRutFieldHasError),
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountOwnerRut",
          label: 'Rut del titular',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: accountEmail.value,
          "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((accountEmail).value = $event)),
          "has-error": _unref(accountEmailFieldHasError),
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountEmail",
          label: 'Correo electrónico del titular',
          "hide-details": ""
        }, null, 8, ["model", "has-error"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "success ml-auto",
        onClick: registerNewAccount,
        disabled: _unref(formHasError)
      }, " Crear nueva cuenta ", 8, _hoisted_3)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})